angular.module('dnecom')
    .controller('StoreDashboardController', ["$scope", function StoreDashboardController($scope) {
        $scope.transactions = TemplateData.value('transactions');
    }]);
